export default "/dist/blocks.style.build.css";